import React from 'react'

import styled from '@emotion/styled'
import { useTheme } from '@gousto-internal/citrus-react'

import { DiscountBarContainerProps } from './DiscountBarContainer'

export type StyledButtonProps = Omit<DiscountBarContainerProps, 'applyDiscount'> & {
  role: string
  tabIndex: number
  onClick: () => void
}

export const StyledButton = (props: StyledButtonProps) => {
  const { theme } = useTheme()
  const { isHidden, isSticky } = props
  const breakpointFromMedium = `@media (min-width: ${theme.tokens.breakpoints[0]})`

  const Component = styled.div({
    display: 'none',
    backgroundColor: theme.tokens.colors.Secondary_400,
    width: '100%',
    minHeight: '3.75rem',
    padding: '1rem',
    alignItems: 'center',
    justifyContent: 'center',

    [breakpointFromMedium]: {
      display: isHidden ? 'none' : 'flex',
      minHeight: '3rem',
      padding: '0',
      ...(isSticky
        ? {
            position: 'fixed',
            top: 0,
            zIndex: theme.tokens.zIndices.Sticky,
          }
        : {}),
    },
  })

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Component {...props} />
}
